import { render, staticRenderFns } from "./ChannelModal.vue?vue&type=template&id=eb178c0e&scoped=true"
import script from "./ChannelModal.vue?vue&type=script&lang=js"
export * from "./ChannelModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelModal.vue?vue&type=style&index=0&id=eb178c0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb178c0e",
  null
  
)

export default component.exports